// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PromotionBanner_wrapper__3l7uX"};